<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>


      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>


      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Bina" prop="Bina_id">
                <el-select @change="SayacGetir()" v-model="Form.Bina_id" filterable clearable>
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Okumalar" prop="Sayac_id">
                <el-select v-model="Form.Sayac_id" :disabled="SayacDisplay" filterable>
                  <el-option
                    v-for="item in SayacListe"
                    :key="item.id"
                    :label="item.Kategori"
                    :value="item.id">
                    <span style="float: left">{{ item.Kategori }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Tarih }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="3" :offset="13">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>


        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs "

            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter"
          >
            <el-table-column
              label="Mesken Bilgi"
              prop="Bilgi">
            </el-table-column>
            <el-table-column
              label="İlk Endeks"
              prop="iEndeks"
              width="150">
            </el-table-column>
            <el-table-column
              label="Son Endeks"
              prop="sEndeks"
              width="150">
            </el-table-column>
            <el-table-column
              label="Fark Endeks"
              prop="Fark"
              width="150">
            </el-table-column>
            <el-table-column
              v-if="Ortak"
              label="Tüketim Bedeli"
              width="150"
              prop="tTutar">
            </el-table-column>
            <el-table-column
              v-if="Ortak"
              label="Ortak Tutar"
              width="150"
              prop="oTutar">
            </el-table-column>


            <el-table-column
              label="Toplam Tutar"
              prop="Tutar"
              width="150"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import Yukleniyor from "../../components/Doc/Yukleniyor";


  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));


  export default {
    components: {Yukleniyor},
    data() {
      return {
        Height: 0,
        DefterTur: '',
        lo: false,
        Yetki: false,
        Ortak: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Sayaç Raporu',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Bina_id: null,
          Sayac_id: null
        },
        FormHata: {
          Sayac_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        MakbuzDetayModal: false,
        mNo: null,
        Kategoriler: [],
        Binalar: [],
        Siteler: [],
        tableData: [],
        ExcelData: [],
        SayacListe: [],
        SayacDisplay: false,
        tableDisplay: false,
        AltToplam: []

      }
    },
    methods: {

      Excel(evt) {

        const ws = XLSX.utils.json_to_sheet(this.ExcelData);
        const wb = XLSX.utils.book_new();
        ws['!cols'] = [
          {wch: 15},
          {wch: 12},
          {wch: 12},
          {wch: 12},
          {wch: 12},
          {wch: 12},
          {wch: 12},
        ];

        wb.Props = {
          Title: this.Sayfa.Adi,
          Author: "Aidatim APP",
          Manager: "Aidatim APP",
          Company: "Aidatim",
          Category: "Finans",
          Keywords: "Aidatim",
          Comments: this.Sayfa.Adi,
        };
        XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
        XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
      },
      Yazdir() {
        window.print();
      },
      TableFooter() {
        return this.AltToplam;
      },
      Getir() {
        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'raporlama/sayac/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.tableData;
                  this.AltToplam = response.AltToplam;
                  this.ExcelData = response.ExcelData;
                  this.Ortak = response.Ortak;
                  if (this.tableData) this.tableDisplay = true;
                  this.Height = window.innerHeight - 220
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },
      SayacGetir() {
        this.$store.dispatch("Get", {path: 'iptal/sayac/' + this.Form.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.SayacListe = response.Liste
              this.SayacDisplay = false;
            } else {
              this.$message.error(response.Mesaj);
              this.SayacListe = [];
              this.SayacDisplay = true;
              this.Form.Sayac_id = null;
              this.hata = response.Hata;
            }
          });
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });


      },
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
        this.SayacGetir();
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/sayac.vue